module.exports = __webpack_public_path__ + "static/media/ewager-white-clear-cropped.7224bf2f.svg";